<template>
  <div class="input__container" :class="classes">
    <div class="input__holder">
      <label id="input__label" ref="placeholder" @click="focus">{{ placeholder }}</label>
      <form v-on:submit.prevent>
        <input ref="input__field" class="test" :type="type" v-model="input" @focus="focus" @blur="blur"
               @input="onChange" :maxLength=maxLength :minLength=minLength v-on:keyup.enter="$emit('onEnter')"/>
      </form>
      <div class="dropdown__container" v-if="select && showDropdown">
        <p v-for="option in tempOptions" :key="option.id" @click="selectedOption(option)">{{ option.name }}</p>
      </div>
    </div>
    <p class="error" v-if="err.length > 0">* {{ err[0] }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      input: this.value ? this.value + '' : '',
      err: this.error + '',
      showDropdown: false,
      tempOptions: Object.assign([], this.selectOptions)
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'Type here..'
    },
    value: String,
    attr: {
      type: String,
      default: null
    },
    maxLength: {
      type: String,
      default: '2000'
    },
    minLength: {
      type: String,
      default: '0'
    },
    error: {
      type: Array,
      default () {
        return []
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: function () {
        return []
      }
    },
    select: {
      type: Boolean,
      default: false
    },
    selectOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    autocomplete: {
      type: String,
      default: ''
    }
  },
  methods: {
    blur () {
      this.$emit('onBlur')
      if (this.input === '' && !this.showDropdown) {
        this.$refs['placeholder'].classList.remove('moveLabel')
        if (this.required) {
          this.error = 'This field is required'
        }
      } else if (this.showDropdown) {
        var self = this
        setTimeout(function () {
          if (self.input === '') {
            self.showDropdown = false
            self.$refs['placeholder'].classList.remove('moveLabel')
          }
        }, 100)
      }
    },
    focus () {
      this.$refs['input__field'].focus()
      if (this.value === '') {
        this.$refs['placeholder'].classList.add('moveLabel')
      }
      if (this.select) {
        this.showDropdown = true
      }
    },
    onChange () {
      var length = this.input.length
      var lastChar = this.input[length - 1]

      if (this.required && this.error === 'This field is required') {
        this.error = null
      }

      if (this.select) {
        this.filterSelect()
      }

      if (this.input !== '') {
        if (this.type === 'creditCardNumber') {
          if (lastChar !== '-') {
            if (isNaN(parseInt(lastChar))) {
              this.input = this.input.substring(0, length - 2)
              return
            } else {
              this.formatCreditCardNumber()
            }
          } else {
            this.input = this.input.substring(0, length - 1)
          }
        } else if (this.type === 'creditExpDate') {
          if (lastChar !== '/') {
            if (isNaN(parseInt(lastChar))) {
              this.input = this.input.substring(0, length - 2)
              return
            } else {
              this.formatCreditExpDate()
            }
          } else {
            this.input = this.input.substring(0, length - 1)
          }
        } else if (this.type === 'creditCVV') {
          if (isNaN(parseInt(lastChar))) {
            this.input = this.input.substring(0, length - 2)
            return
          } else {
            if (this.input > 999) {
              this.input = this.input.substring(0, length - 1)
            }
          }
        }
      }
      if (this.attr) {
        this.$emit('onChange', this.attr, this.input)
      } else {
        this.$emit('onChange', this.input)
      }
    },
    filterSelect () {
      this.tempOptions = this.selectOptions.filter(item => {
        return item.name.toLowerCase().includes(this.input.toLowerCase())
      })
    },
    formatCreditCardNumber () {
      var length = this.input.length
      var lastChar = this.input[length - 1]

      if (length === 5) {
        this.input = this.input.substring(0, 4) + '-' + lastChar
      } else if (length === 10) {
        this.input = this.input.substring(0, 9) + '-' + lastChar
      } else if (length === 15) {
        this.input = this.input.substring(0, 14) + '-' + lastChar
      }
    },
    formatCreditExpDate () {
      var length = this.input.length
      var lastChar = this.input[length - 1]

      if (length === 2) {
        if (parseInt(this.input) > 12) {
          this.input = '12'
        }
      } else if (length === 3) {
        this.input = this.input.substring(0, 2) + '/' + lastChar
      }
    },
    selectedOption (option) {
      this.input = option.name + ''
      this.showDropdown = false
      this.filterSelect()
      this.$emit('onSelect', option)
    }
  },
  mounted () {
    this.$refs['input__field'].addEventListener('animationstart', function () {
      // self.$refs['placeholder'].classList.add("moveLabel")
    })
  },
  watch: {
    value: {
      handler (val) {
        if (val !== '') {
          this.input = val + ''
        } else {
          this.input = ''
          if (!this.$refs['input__field'].hasFocus()) {
            this.$refs['placeholder'].classList.remove('moveLabel')
          }
        }
      },
      deep: true
    },
    error: {
      handler (val) {
        this.err = val
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .input__container {
    position: relative;
    margin-bottom: 5px;

    #input__label {
      position: absolute;
      transition: .3s all ease-in-out;
      top: 10px;
      font-family: "RobotoRegular";
      font-size: 14px;
      color: #525869;
      font-weight: 400;
      margin-left: 0;
      cursor: text;

      &.moveLabel {
        top: -5px;
        font-size: 12px;
      }
    }

    .input__holder {
      position: relative;
    }

    @keyframes onAutoFillStart {
      from { /**/
      }
      to { /**/
      }
    }
    @keyframes onAutoFillCancel {
      from { /**/
      }
      to { /**/
      }
    }

    input {
      border: none;
      border-bottom: 1px solid #BDC6D3;
      width: calc(100% - 10px);
      font-family: "RobotoRegular";
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 5px;
      color: #525869;
      box-sizing: border-box;

      &:-webkit-autofill {
        animation-name: onAutoFillStart;
        transition: background-color 50000s ease-in-out 0s;
      }

      &:not(:-webkit-autofill) {
        animation-name: onAutoFillCancel;
      }

      &.is-autofilled {
        border: none;
      }
    }

    .error {
      margin: 0;
      padding: 0;
      font-size: 12px;
      color: red;
      font-family: "RobotoMedium";
      margin-top: 2px;
    }

    .dropdown__container {
      position: absolute;
      top: 100%;
      left: 0;
      max-height: 200px;
      max-width: 200px;
      background: #fff;
      box-shadow: 0px 2px 4px #b0b7c1;
      border: .5px solid #e5e5e5;
      overflow-y: auto;
      z-index: 99;

      p {
        padding: 5px;
        margin-bottom: 0;
        font-size: 14px !important;
        color: #9CA4AF;
        font-family: "RobotoRegular";
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          background: #EEEFF1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/CustomInput.vue